import * as Event from '../Event/index.js';
import { Playback } from './Playback.js';
export class Capture extends Event.Dispatcher {
    constructor() {
        super(...arguments);
        this.blobs = [];
        this.recording = false;
        this.url = '';
    }
    static play() {
        return Capture.instance.play();
    }
    static start() {
        return Capture.instance.start();
    }
    static stop() {
        return Capture.instance.stop();
    }
    play() {
        const url = this.toUrl();
        const element = Playback.play(url);
        return element;
    }
    start() {
        if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
            return Promise.reject(new Error('mediaDevices API or getUserMedia method is not supported in this browser.'));
        }
        return navigator.mediaDevices
            .getUserMedia({
            audio: true,
            video: false,
        })
            .then((stream) => {
            this.blobs = [];
            this.stream = stream;
            console.log('🎵 Starting Audio Capture');
            this.recording = true;
            this.mediaRecorder = new MediaRecorder(stream);
            this.mediaRecorder.addEventListener('dataavailable', (e) => {
                this.blobs.push(e.data);
            });
            this.mediaRecorder.start();
        })
            .catch(() => {
            alert('Failed to start capturing audio. Please enable your microphone.');
        });
    }
    stop() {
        if (!this.mediaRecorder) {
            console.warn('No Audio Capture to stop');
            return;
        }
        return new Promise((resolve) => {
            var _a, _b;
            let mimeType = (_a = this.mediaRecorder) === null || _a === void 0 ? void 0 : _a.mimeType;
            console.log('🎵 Stopping Audio Capture');
            (_b = this.mediaRecorder) === null || _b === void 0 ? void 0 : _b.addEventListener('stop', () => {
                this.blob = new Blob(this.blobs, { type: mimeType });
                this.url = this.toUrl();
                resolve(this.blob);
            });
            this.recording = false;
            this.cancel();
        });
    }
    cancel() {
        this.stopStream();
        this.reset();
    }
    toObject() {
        return {
            loop: false,
            offset: 0,
            url: this.toUrl(),
            volume: 1,
        };
    }
    toUrl() {
        return this.url || URL.createObjectURL(this.blob);
    }
    createAudioElement() {
        const audio = document.createElement('audio');
        audio.controls = true;
        audio.src = this.toUrl();
        return audio;
    }
    stopStream() {
        var _a, _b;
        (_a = this.mediaRecorder) === null || _a === void 0 ? void 0 : _a.stop();
        (_b = this.stream) === null || _b === void 0 ? void 0 : _b.getTracks().forEach((track) => track.stop());
    }
    reset() {
        delete this.mediaRecorder;
        delete this.stream;
    }
}
Capture.instance = new Capture();
//# sourceMappingURL=data:application/json;base64,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